<!-- Loading indicator -->
<div *ngIf="loading" class="container py-5 text-center">
  <div class="spinner-border" role="status">
    <span class="visually-hidden">{{ 'common.loading' | transloco }}</span>
  </div>
  <p class="mt-3">{{ 'job.detail.loading' | transloco }}</p>
</div>

<!-- Error message -->
<div *ngIf="error" class="container py-5">
  <div class="alert alert-danger">
    {{ error }}
  </div>
</div>

<!-- Job content when loaded -->
<ng-container *ngIf="!loading && !error && job">
  <!-- Hero section with breadcrumbs and job title -->
  <app-job-apply-hero [job]="job" [matchScore]="matchScore"></app-job-apply-hero>

  <section class="job-apply">
    <div class="container">
      <div class="job-apply-columns">
        <app-job-apply-form [jobId]="job.id.toString()" (profileDataChange)="onProfileEdit()"></app-job-apply-form>
        <app-job-apply-sidebar [job]="job"></app-job-apply-sidebar>
      </div>
    </div>
  </section>
</ng-container>
